import { Link, useLocation, useParams } from 'react-router-dom';
import { Loading } from '../../components/Loading';
import ErrorMessageBox from '../../components/ErrorMessageBox';
import moment from 'moment';
import { useQuery } from "@tanstack/react-query";
import Api, { createFetchErrorMessage } from 'utils/api/Api';
import { NoticeImages } from './partials/NoticeImages';
import { NoticeFiles } from './partials/NoticeFiles';
import sanitizeHtml from 'sanitize-html';
import { sanitizeOption } from 'lib/sanitizeHtml';

export const NoticeView = ()=>{
    const location = useLocation();
    const { id, school } = useParams();

    const {data:notice, isLoading, isError, error } =useQuery({
        queryKey:['notice/view', id],
        queryFn:()=>Api.get(`/api/notice/${id}`)
    });

    if( isLoading ){
        return (
            <div className="section">
                <div className="inner">
                    <div className="bbs_view">
                        <Loading />
                    </div>
                </div>
            </div>
        );
    }
    if( isError ) return <ErrorMessageBox  message={createFetchErrorMessage(error).message}
                                goto={<Link className="btn _border" to={`/${school}/notice${location.search}`} >목록</Link>} />
    if(notice.notice===null)return null;

    return (
        <div className="section">
            <div className="inner">
                <div className="bbs_view">
                    <div className="title_area">
                        <h3>{notice.data?.title}</h3>
                        <div className="info_wrap clear">
                            <div className="date"><span>등록일</span><span>{ moment(notice.data?.createdAt).format('LLL') }</span></div>
                            <div className="hit"><span>조회</span><span>{notice.data?.readCount}</span></div>
                        </div>
                    </div>
                    
                    <NoticeImages notice={notice} />
                    <div className="cont_area editor_view" dangerouslySetInnerHTML={ { __html: sanitizeHtml(notice.data?.content, sanitizeOption) } }></div>
                    <NoticeFiles notice={notice} />
                </div>

                <div  className="bbs_btn alignC">
                    <Link className="btn _border" to={`/${school}/notice${location.search}`}>
                        목록
                    </Link>
                </div>
            </div>
        </div>
    );
};